module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Anemone Bowl")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#child"
    }
  }, [_vm._v("Child")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#prologue"
    }
  }, [_vm._v("Prologue")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-1-first-walk"
    }
  }, [_vm._v("Chapter 1: First Walk")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-2-the-bowl"
    }
  }, [_vm._v("Chapter 2: The Bowl")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-3-eryne"
    }
  }, [_vm._v("Chapter 3: Eryne")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-4-setting-a-course"
    }
  }, [_vm._v("Chapter 4: Setting a Course")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#chapter-5-whack"
    }
  }, [_vm._v("Chapter 5: Whack")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-6-stella",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Stella")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#child-on-learning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On Learning")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-7-mrs-rhondel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Mrs Rhondel")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#child-life-as-attitude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: Life as Attitude")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-8-a-portrait-of-a-young-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: A Portrait of a Young Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-9-footbridges",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Footbridges")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#child-do-not-spit-on-people",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: Do Not Spit on People")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-10-losing-a-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Losing a Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-11-up-the-valley",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Up the Valley")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#child-on-god-and-other-gods",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On God and Other Gods")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-12-the-crossing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Crossing")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-13-the-ballet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Ballet")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-14-aspects-of-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Aspects of Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#child-on-character",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On Character")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-15-the-road-to-the-village",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Road to the Village")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-16-reading-a-future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Reading a Future")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-17-a-visit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: A Visit")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-18-the-pool-of-time-the-tale-of-ibrahim-and-yussuf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Pool of Time: The Tale of Ibrahim and Yussuf")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-19-clive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Clive")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#child-on-sloth-you-say",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On Sloth (You Say)")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-20-jacks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Jack’s")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-21-jack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Jack")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-22-danse-macabre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Danse Macabre")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#child-on-the-wherewithal-of-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On the Wherewithal of War")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-23-a-way-forward",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: A Way Forward")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-24-reflections-on-a-life-gone-by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Reflections on a Life Gone By")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#child-on-aging-and-death",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child: On Aging and Death")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-25-the-stairs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: The Stairs")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-26-lessons-in-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Lessons in Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-27-path-to-the-river",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Path to the River")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-28-final-accountings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Final Accountings")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#the-child-speaks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Child Speaks")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#a-prayer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prayer")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0